export default {
    accountManagement: 'Comptes',
    userManagement: 'Utilisateurs',

    lockNavigation: 'Verrouiller la navigation',
    unlockNavigation: 'Déverrouiler la navigation',

    sidebar: {
        webOrderBadgeTooltip: 'Commande web active en attente | Commandes web actives en attente',
        activityReport: '@:dashboards.activityReport',
        allLead: '@:dashboards.allLead',
        automations: 'Automatisations',
        campaign: 'Campagne',
        commercial: 'Dir. commercial',
        duplicates: 'Doublons',
        event: '@:dashboards.event',
        flow: 'Procédure',
        headers: {
            client: 'Client',
            management: 'Gestion',
            tools: 'Outils',
        },
        homepage: 'Accueil',
        import: 'Importation',
        inventory: 'Inventaire',
        inTurn: 'Tour de rôle',
        analytics: 'Analyses',
        leadXpress: '@:dashboards.leadXpress',
        loyalty: '@:dashboards.loyalty',
        niotext: 'Niotext',
        objectives: 'Objectifs',
        phoneUp: '@:dashboards.phoneUp',
        renewal: '@:dashboards.renewal',
        templates: 'Modèles',
        saleTable: '@:dashboards.saleTable',
        schedule: 'Horaire',
        service: '@:dashboards.service',
        sms: 'SMS',
        smsBadgeTooltip: 'Message non lu | Messages non lus',
        trash: 'Corbeille',
        walkIn: '@:dashboards.walkIn',
        webBoost: '@:dashboards.webBoost',
        webOrder: '@:dashboards.webOrder',
    },
    supportModal: {
        title: 'Support',
        contactPre: "Si vous avez des questions, n'hésitez pas à communiquer avec notre équipe",
        contactMid: 'ou à appeler notre numéro sans frais au',
        contactPhone: '1-866-430-6767',
        contactPost: '. Il nous fera plaisir de vous aider.',
        trainingPre:
            "Vous aimeriez mieux maîtriser l'utilisation du CRM? Passez à l'étape suivante avec",
        trainingLink: 'Activix EXP',
        youtubePre: 'Voici notre',
        youtubeLink: 'chaîne YouTube',
        youtubePost:
            ', où vous trouverez des tutoriels et des conseils sur les meilleures pratiques.',
        linkedinPre:
            "Vous voulez lire davantage de contenu sur l'industrie automobile? Consultez notre",
        linkedinLink: 'page LinkedIn',
    },
    userDropdown: {
        accounts: 'Comptes',
        changelog: 'Mise à jour',
        disconnect: 'Déconnexion',
        groups: 'Groupes',
        training: 'Formation',
        help: 'Aide',
        myAccount: 'Mon compte',
        myProfile: 'Mon profil',
        suggestions: 'Suggestions',
        users: 'Utilisateurs',
        turnOffNotifications: 'Suspendre les notifications',
        turnOffNotificationsDetails:
            "Voulez-vous suspendre la réception de notification et les rediriger vers l'écran ?",
        turningOnNotifications: 'Les notifications ont été réactivées.',
    },
};
